import { render } from "./ValidationEmailView.vue?vue&type=template&id=54b2779d&scoped=true&ts=true"
import script from "./ValidationEmailView.vue?vue&type=script&lang=ts"
export * from "./ValidationEmailView.vue?vue&type=script&lang=ts"

import "./ValidationEmailView.vue?vue&type=style&index=0&id=54b2779d&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b2779d"]])

export default __exports__